export enum ParkingEnum {
  あり = "あり",
  なし = "なし"
}
